import axios from "axios";
import { decryptData, encryptPayload } from "./decryptBody";
import { alertaGeneral } from "./alertas";

const apiClient = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}`
});

//Interceptor para enviar el token
apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    
    // IMPORTANTE: Para FormData, NO establecer Content-Type manualmente
    // El navegador lo establecerá automáticamente con el boundary correcto
    if (config.data instanceof FormData) {
        // Eliminar Content-Type para que el navegador lo establezca automáticamente
        delete config.headers['Content-Type'];
    }
    
    //Encriptamos el payload siempre y cuando no sea un FormData
    /*
    if (config.data && (Object.prototype.toString.call(config.data) !== '[object FormData]')) {
        config.data = encryptPayload(config.data);
    }
    */

    return config;
});

apiClient.interceptors.response.use(
    async (response) => {
        // Si el backend devuelve datos encriptados, descomenta las siguientes líneas:
        // const data = await decryptData(response.data.d, response.data.in);
        // response.data = data;
        return response;
    },
    async (error) => {
        // Si el backend devuelve errores encriptados, descomenta las siguientes líneas:
        // const data = await decryptData(error.response.data.d, error.response.data.in);
        // error.response.data = data;
        
        console.error('API Error:', {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            url: error.config?.url
        });

        // Manejar errores de red PRIMERO (antes de verificar status codes)
        // Los errores de red/CORS no tienen response, así que no debemos limpiar la sesión
        if (!error.response) {
            console.error('Network error:', error.message);
            error.code = 'NETWORK_ERROR';
            // NO limpiar la sesión en errores de red/CORS
            // Solo rechazar la promesa para que el componente maneje el error
            return Promise.reject(error);
        }

        // Manejar errores de autenticación SOLO si hay una respuesta del servidor
        // Esto evita limpiar la sesión en errores de red/CORS
        if (error.response?.status === 401) {
            // Verificar que el error sea realmente de autenticación y no de CORS
            // Si el error no tiene datos o es un error de CORS, no limpiar la sesión
            const errorMessage = error.response?.data?.message || '';
            const isAuthError = errorMessage.includes('token') || 
                               errorMessage.includes('Access denied') || 
                               errorMessage.includes('autenticación') ||
                               errorMessage.includes('sesión');
            
            if (isAuthError) {
                console.log("Token expirado o inválido");
                localStorage.clear();
                alertaGeneral({
                    titulo: "Sesión expirada",
                    messageHtml: "Tu sesión ha expirado. Por favor, inicia sesión nuevamente.",
                    isError: true
                }).then(() => {
                    window.location.href = "/login";
                });
            }
            return Promise.reject(error);
        }

        return Promise.reject(error);
    }
);

export default apiClient;